import type { IGetOrderDeliveryLimits } from "@jti/magento";
import { useSelector } from "@jti/store/reduxHooks";
import { selectOrderDeliveryLimits } from "@jti/store/selectors/selectOrderDeliveryLimits";
import { fetchFreeTrialOrderDeliveryLimits, fetchOrderDeliveryLimits } from "@jti/store/slices/LEGACY__checkoutSlice";

import { useFreeTrial } from "@checkout/hooks/useFreeTrial";

type UseShippingValue = {
  isFreeTrial: boolean;
  isTrialEligible?: boolean;
  cartId?: string;
  orderDeliveryLimits: IGetOrderDeliveryLimits;
  fetchDeliveryLimit: typeof fetchOrderDeliveryLimits;
};

type UseShipping = () => UseShippingValue;

const useShipping: UseShipping = () => {
  const { isFreeTrial, freeTrialId } = useFreeTrial();
  const orderDeliveryLimits = useSelector(selectOrderDeliveryLimits);
  const freeTrialDeliveryLimits = useSelector((state) => state.freeTrialCart.checkout.orderDeliveryLimits.data);
  const cartId = useSelector((state) => state.cart.id);
  const isTrialEligible = useSelector((state) => state.freeTrialCart.isTrialEligible);

  return {
    isFreeTrial,
    isTrialEligible,
    cartId: isFreeTrial ? freeTrialId : cartId,
    orderDeliveryLimits: isFreeTrial ? freeTrialDeliveryLimits : orderDeliveryLimits,
    fetchDeliveryLimit: isFreeTrial ? fetchFreeTrialOrderDeliveryLimits : fetchOrderDeliveryLimits,
  };
};

export default useShipping;
